<template>
  <section>
    <qx-custom-form
        :noSubBtn="true"
        ref="baseForm"
        :formData="baseForm"
        labelWidth="140px">
      <div class="tip" slot="pathOriginTip">{{this.otherFormData.startPoint }}</div>

      <div class="tip" slot="pathEndPointTip">{{this.otherFormData.endPoint }}</div>

      <section slot="routeType" slot-scope="prop" style="text-align: center;margin-bottom:20px">
        <span v-for="(item,index) in pathType" @click="pathTypeChange(index)" style="margin-right: 10px" v-if="!$route.query.id">
          <el-button :type="otherFormData.pathTypeIndex===index?'primary':''">{{ item }}</el-button>
        </span>
        <el-button type="primary" :disabled="Boolean($route.query.id)"  v-if="$route.query.id">{{pathType[otherFormData.pathTypeIndex]}}</el-button>

        <div style="margin-top:20px">
          <el-button type="warning" v-if="otherFormData.time">{{ otherFormData.time }}</el-button>
          <el-button type="warning" v-if="otherFormData.distance">{{ otherFormData.distance }}</el-button>
        </div>
      </section>
    </qx-custom-form>
  </section>
</template>

<script>
import {dealNumber} from '@qx/utils';

export default {
  components: {
  },
  data () {
    return {
      otherFormData: {
        pathTypeIndex: 0, // 路径规划类型（0：不走高速、1：时间最短、2：距离最短）
        time: null, // 最短时间
        distance: null, // 最短距离
        steps: [], // 路径全部点的经纬度信息
        startInfo: {}, // 路径起点
        endInfo: {}, // 路径终点
        startPoint: null, // 起点经纬度
        endPoint: null, // 终点经纬度
      },
      pathType: ['不走高速', '时间最短', '距离最短'],
      baseForm: {
        orgIdOptions: [], // 适用部门
        form: [
          {
            label: '路径名称',
            value: 'pathName',
            type: 'input',
            placeholder: '请输入路径名称',
          },
          {
            label: '路径有效时间',
            value: 'dependTime',
            type: 'date',
            placeholder: '请选择有效时间区间',
            attr: {
              type: 'datetimerange',
            },
            pickerOptions: {
              disabledDate (time) {
                return time.getTime() < Date.now() - 24 * 3600 * 1000;

              },
            },
          },
          {
            label: '限速值（km/h）',
            value: 'rateLimitingValue',
            type: 'input',
            placeholder: '请输入路径内最高时速',
            onInput: (rateLimitingValue) => {
              this.$refs.baseForm.setVal('rateLimitingValue', dealNumber(rateLimitingValue, false));
            },
          },
          {
            label: '超速持续时间（秒）',
            value: 'overspeedDuration',
            type: 'input',
            placeholder: '请输入超速后最长持续时间',
            onInput: (overspeedDuration) => {
              this.$refs.baseForm.setVal('overspeedDuration', dealNumber(overspeedDuration, false));
            },
          },
          {
            label: '路径起点',
            value: 'pathOrigin',
            type: 'input',
            placeholder: '请输入路径起点',
            onBlur: () => {
              const pathOrigin = this.$refs.baseForm.getVal('pathOrigin');
              const pathEndPoint = this.$refs.baseForm.getVal('pathEndPoint');
              if (pathEndPoint) {
                this.$emit('pathTypeChange', pathOrigin, pathEndPoint, this.otherFormData.pathTypeIndex);
              } else {
                this.otherFormData.startPoint = null;
              }
            },
            hide: true,
          },
          {
            label: '路径起点',
            value: 'pathOriginShow',
            type: 'show',
            hide: true,
          },
          {
            label: '路径终点',
            value: 'pathEndPoint',
            type: 'input',
            placeholder: '请输入路径终点',
            onBlur: () => {
              const pathOrigin = this.$refs.baseForm.getVal('pathOrigin');
              const pathEndPoint = this.$refs.baseForm.getVal('pathEndPoint');
              if (pathOrigin) {
                this.$emit('pathTypeChange', pathOrigin, pathEndPoint, this.otherFormData.pathTypeIndex);
              } else {
                this.otherFormData.endPoint = null;
              }
            },
            hide: true,
          },
          {
            label: '路径终点',
            value: 'pathEndPointShow',
            type: 'show',
            hide: true,
          },
          {
            label: '备注',
            value: 'remark',
            type: 'input',
            placeholder: '请输入备注',
          },
          {
            label: '',
            value: 'routeType',
            allCustom: true,
          },
          {
            label: '适用部门',
            value: 'orgId',
            type: 'select',
            default: [],
            placeholder: '请选择适用部门',
          },
        ],
        rules: {
          pathName: [
            { required: true, message: '请输入路径名称', trigger: 'blur' },
          ],
          dependTime: [
            { required: true, message: '请选择有效时间区间', trigger: 'blur' },
          ],
          pathOrigin: [
            { required: true, message: '请输入正确的路径起点', trigger: ['blur', 'change'] },
          ],
          pathEndPoint: [
            { required: true, message: '请输入正确的路径终点', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async setList (options) {
      this.baseForm.orgIdOptions = options.orgIdOptions;
    },
    // 路径规划方式改变
    pathTypeChange (val) {
      this.otherFormData.pathTypeIndex = val;
      const pathOrigin = this.$route.query.lineId || this.$route.query.id ? this.$refs.baseForm.getVal('pathOriginShow') : this.$refs.baseForm.getVal('pathOrigin');
      const pathEndPoint = this.$route.query.lineId || this.$route.query.id ? this.$refs.baseForm.getVal('pathEndPointShow') : this.$refs.baseForm.getVal('pathEndPoint');
      if (pathOrigin && pathEndPoint) {
        this.$emit('pathTypeChange', pathOrigin, pathEndPoint, val);
      }
    },
    startPoint (val) {
      if (!val) {
        this.otherFormData.startPoint = null;
        this.$refs.baseForm.setVal('pathOrigin', null);
        this.baseForm.rules.pathOrigin[0].required = true;
      } else {
        this.otherFormData.startPoint = '经度:' + val.lng + '          ' + '纬度:' + val.lat;
      }
    },
    endPoint (val) {
      if (!val) {
        this.otherFormData.endPoint = null;
        this.$refs.baseForm.setVal('pathEndPoint', null);
        this.baseForm.rules.pathEndPoint[0].required = true;
      } else {
        this.otherFormData.endPoint = '经度:' + val.lng + '          ' + '纬度:' + val.lat;
      }
    },
    distanceDetail (time, distance, steps, startInfo, endInfo) {
      this.otherFormData.time = time;
      this.otherFormData.distance = distance;
      this.otherFormData.steps = steps;
      this.otherFormData.startInfo = startInfo;
      this.otherFormData.endInfo = endInfo;
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData.startDate = formData.dependTime ? this.formatDate(formData.dependTime[0], 1) : null; // 路径开始时间
        formData.endDate = formData.dependTime ? this.formatDate(formData.dependTime[1], 1) : null; // 路径结束时间
        delete formData.dependTime;
        formData.sourceEand = this.otherFormData.startInfo.lng;// 起点经度
        formData.sourceNand = this.otherFormData.startInfo.lat;// 起点纬度
        formData.desEand = this.otherFormData.endInfo.lng;// 终点经度
        formData.desNand = this.otherFormData.endInfo.lat;// 终点纬度
        formData.locationInformations = JSON.stringify(this.otherFormData.steps);// 规划路线的所有经纬度信息
        formData.routeType = this.otherFormData.pathTypeIndex; // 路径规划类型
        if (this.$route.query.lineId) {
          formData.pathOrigin = formData.pathOriginShow;
          formData.pathEndPoint = formData.pathEndPointShow;
        }
        delete formData.pathOriginShow;
        delete formData.pathEndPointShow;
      }
      console.log('eeee', formData);
      return formData;
    },

    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async sub () {
      const res = await this.handleSubData();
      return res;
    },
    formChange () {
      // lineId是从客户线路跳转过来的，id是列表点“路径名称”查看路径的
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: this.$route.query.lineId || this.$route.query.id,
        names: ['pathOrigin', 'pathEndPoint'],
      });
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: !this.$route.query.lineId && !this.$route.query.id,
        names: ['pathOriginShow', 'pathEndPointShow'],
      });
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: Boolean(this.$route.query.lineId),
        names: ['dependTime', 'rateLimitingValue', 'overspeedDuration', 'remark', 'orgId'],
      });
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: Boolean(this.$route.query.id),
      });

    },
    async init (data = {}) {
      this.formChange();
      if (data.orgId === undefined || data.orgId === null) {
        data.orgId = this.baseForm.orgIdOptions[0].value;
      }
      // 从客户线路跳转过来
      if (this.$route.query.lineId) {
        data.pathName = decodeURIComponent(this.$route.query.pathName);
        data.dependTime = [this.formatDate(+this.$route.query.effectBegin, 1), this.formatDate(+this.$route.query.effectEnd, 1)];

        data.pathOriginShow = decodeURIComponent(this.$route.query.sourceAddress);
        data.pathEndPointShow = decodeURIComponent(this.$route.query.desAddress);
      }
      // 列表点“路径名称”跳转过来
      if (this.$route.query.id) {
        data = data.items[0];
        data.pathOriginShow = data.pathOrigin;
        data.pathEndPointShow = data.pathEndPoint;
        data.dependTime = [this.formatDate(data.startDate, 1), this.formatDate(data.endDate, 1)];
        data.overspeedDuration = data.overspeedDurationDouble;
        data.rateLimitingValue = data.rateLimitingValueDouble;
        this.otherFormData.pathTypeIndex = data.routeType;
      }
      this.$refs.baseForm.setVal(data);
      if (this.$route.query.lineId) {
        await this.pathTypeChange(0);
      }
      if (this.$route.query.id) {
        await this.pathTypeChange(this.otherFormData.pathTypeIndex);
      }

    },
  },

};
</script>

<style scoped lang="scss">

</style>
